import { render, staticRenderFns } from "./createclass.vue?vue&type=template&id=7bc685cf&scoped=true"
import script from "./createclass.vue?vue&type=script&lang=js"
export * from "./createclass.vue?vue&type=script&lang=js"
import style0 from "./createclass.vue?vue&type=style&index=0&id=7bc685cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc685cf",
  null
  
)

export default component.exports